module.exports = __webpack_public_path__ + "static/media/bulk_shipping_type_upload.048c95b5.csv";